import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'email', 'updated_at'];

export const getInvitations = asyncThunkWrapper({ 
  model: 'invitations', 
  action: 'getInvitations', 
  func: async ({ offset = 0, query = null }) => {
    const params = { limit: 10, offset, orders: { updated_at: 'desc' }, attributes, ...(query && { query }) };
    const response = await axios.get(`/invitations`, { params });

    return response.data;
  } 
});
export const createInvitation = asyncThunkWrapper({ 
  model: 'invitations', 
  action: 'createInvitation', 
  func: async (invitation) => {
    const response = await axios.post(`/invitations`, { invitation, attributes });

    return response.data;
  } 
});
export const deleteInvitation = asyncThunkWrapper({ 
  model: 'invitations', 
  action: 'deleteInvitation', 
  func: async (id) => {
    const response = await axios.delete(`/invitations/${id}`);

    return { status: response.status, id };
  } 
});
export const clearLocalInvitations = createAction('invitations/clearLocalInvitations');